import { setCookie } from '@cian/utils/lib/browser/cookie';
import { SHOWN_SALES_START_ONBOARDING_COOKIE_KEY } from '../../constants/salesStartOnboarding';

export function createSalesStartSuccessOnboardingCookie(times: number) {
  setCookie(SHOWN_SALES_START_ONBOARDING_COOKIE_KEY, `${times}`, { secure: false });
}
